<template>
  <div class="u-inline" v-if="bothSigned()">
    <button class="btn-dark u-inline u-margin-right" v-on:click="email()">
      <loading-spinner v-show="loading.email"></loading-spinner>
      <span class="icon" v-show="!loading.email">
        <i class="fa-wrapper fa fa-envelope normal-icon pad-right"></i>
      </span>
      Email KDR
    </button>
    <button class="btn-link u-inline u-margin-right" v-on:click="download()">
      <loading-spinner v-show="loading.download"></loading-spinner>
      <span class="icon" v-show="!loading.download">
        <i class="fa-wrapper fa fa-file-pdf normal-icon pad-right"></i>
      </span>
      Download KDR
    </button>
  </div>
</template>
<script>
import { getKdrAsPDF, getKdrAsEmail } from "@/services/exams.service";
import { handleFileDownload } from "@/functions/handleFileDownload.function";
import LoadingSpinner from "@/components/LoadingSpinner";
import { handleError } from "@/functions/handleError.function";

export default {
  name: "exam-download-kdr",
  data: function() {
    return {
      loading: {
        download: false,
        email: false
      }
    };
  },
  props: {
    exam: {}
  },
  components: {
    LoadingSpinner
  },
  methods: {
    bothSigned: function() {
      return this.exam.candidate_signature && this.exam.supervisor_signature;
    },
    download: function() {
      this.loading.download = true;
      getKdrAsPDF({ id: this.exam.id })
        .then(response => {
          this.loading.download = false;
          let link = handleFileDownload(response);
          link.click();
          setTimeout(() => {
            link.remove();
            window.URL.revokeObjectURL(link.href);
          }, 5000);
        })
        .catch(error => {
          this.loading.download = false;
          var data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    },
    email: function() {
      this.loading.email = true;
      getKdrAsEmail({ id: this.exam.id })
        .then(() => {
          this.loading.email = false;
        })
        .catch(error => {
          this.loading.email = false;
          var data = handleError(error);
          this.$store.commit("core/setError", data);
        });
    }
  }
};
</script>
